<div class="cremation-container">
  <header class="page-header">
    <i class="material-icons header-icon">local_fire_department</i>
    <h1>Einäscherung</h1>
    <p class="subtitle">Anträge und Partnerfriedhöfe</p>
  </header>

  <div class="section-list">
    <div *ngFor="let section of sections" 
         class="section-card"
         [class.active]="isSelected(section.id)"
         (click)="selectSection(section.id)">
      
      <div class="section-header">
        <div class="header-content">
          <i class="material-icons section-icon">place</i>
          <h2>{{ section.title }}</h2>
                </div>
        <button class="expand-button">
          <i class="material-icons">{{ isSelected(section.id) ? 'expand_less' : 'expand_more' }}</i>
        </button>
                        </div>

      <div class="section-content" *ngIf="isSelected(section.id)">
        <div class="document-list" *ngIf="section.documents.length > 0">
          <div *ngFor="let doc of section.documents" class="document-item">
            <a [href]="doc.downloadUrl" 
               target="_blank"
               [class.document-link]="!doc.isExternalLink"
               [class.external-link]="doc.isExternalLink">
              <i class="material-icons">
                {{doc.isExternalLink ? 'open_in_new' : 'description'}}
              </i>
              <div class="document-info">
                <span class="document-title">{{ doc.title }}</span>
                <span *ngIf="doc.stand" class="valid-stand">
                  <i class="material-icons">info</i>
                  Stand {{ doc.stand }}
                </span>
                <span *ngIf="doc.validFrom && !doc.stand" class="valid-from">
                  <i class="material-icons">event</i>
                  Gültig ab {{ doc.validFrom }}
                </span>
                <span *ngIf="doc.validUntil" class="valid-until">
                  <i class="material-icons">event_busy</i>
                  Gültig bis {{ doc.validUntil }}
                </span>
              </div>
            </a>
          </div>
        </div>
        
        <div class="cemetery-link" *ngIf="section.cemeteryLink && !hidePartnerfriedhoefeNav">
          <a (click)="navigateToCemetery(section)" class="cemetery-button">
            <i class="material-icons">place</i>
            <span>{{ section.cemeteryLink.title }}</span>
          </a>
        </div>
      </div>
    </div>
</div>